import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Button, Input } from '@mui/joy';

import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function PromptsSearch({ onSubmit }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [q, setQ] = useState(searchParams.get('q') || '');
  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      onSubmit(q);
    }, 300);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  const handleInputChange = (e) => {
    setQ(e.target.value);
    setSearchParams(
      (prev) => {
        prev.set('q', e.target.value);
        return prev;
      },
      { replace: true }
    );
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(q);
      }}
      className="h-full"
    >
      <Input
        name="q"
        placeholder="Search prompt names, type, prompt tags..."
        value={q}
        onChange={handleInputChange}
        variant="outlined"
        sx={{
          minHeight: 0,
          px: '16px',
          input: { height: '36px', minWidth: '330px', fontSize: '16px' },
          borderColor: 'border-secondary',
        }}
        endDecorator={
          <Button
            variant="plain"
            color="neutral"
            type="submit"
            sx={{ py: '2px', minHeight: 0, color: 'border-secondary' }}
          >
            <MagnifyingGlassIcon className="h-5 w-5" />
          </Button>
        }
      />
    </form>
  );
}
